// extracted by mini-css-extract-plugin
export default {"container":"PayPalButtons_container__e7QKD","disclaimer":"PayPalButtons_disclaimer__a1Tef"};